import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    carouselLabel: string;
    learnMore: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Section title for search suggestions */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestionsCarousel.title?c=2bzpi29t78zr8", defaultMessage: "Suggestions" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for the suggestions carousel */
            carouselLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestionsCarousel.carouselLabel?c=d5crmwiscnig", defaultMessage: "Search suggestions carousel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Link text to learn more about enhanced search */
            learnMore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestionsCarousel.learnMore?c=2bu5tw74q9bww", defaultMessage: "Learn more" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
